<template>
    <v-avatar color="secondary" :size="size" :left="left">
        <v-icon v-if="!user">mdi-account-question</v-icon>

        <img v-else-if="publicImage"
             :src="publicImage.url"
             :title="user.name"
             :alt="user.name" />

        <span v-else class="white--text text-h6" :title="user.name">
            {{ usernameShortcode }}
        </span>
    </v-avatar>
</template>

<script>
import User from "@/models/User/User";
import PublicImage from "@/models/PublicImage/PublicImage";

export default {
    props: {
        size: {
            required: false,
            type: Number,
            default: 40,
        },
        user: {
            required: false,
            type: User,
            default: null,
        },
        left: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    computed: {
        publicImage() {
            if (!this.user) {
                return null;
            }
            return this.user.getRelated('squarePublicImage');
        },
        usernameShortcode() {
            return this.user.name.substr(0, 2);
        },
    },
    watch: {
        'user.square_public_image_id': {
            immediate: true,
            handler() {
                if (!this.user || !this.user.square_public_image_id) {
                    return;
                }

                if (!this.publicImage || this.publicImage.id !== this.user.square_public_image_id) {
                    PublicImage.api().find(this.user.square_public_image_id);
                }
            }
        }
    },
}
</script>
